import { asSingleStyleConfig } from '../../utils/theme';
var baseStyle = {
  px: 3,
  fontSize: 'sm',
  fontWeight: 'semibold',
  lineHeight: '1.75em',
  letterSpacing: '-0.2px',
  color: 'white',
  bg: 'blue.600'
};
function variantSolid() {
  return {
    borderRadius: '4px'
  };
}
function variantPill() {
  return {
    borderRadius: '1.7em',
    px: 3
  };
}
var variants = {
  solid: variantSolid,
  pill: variantPill
};
var defaultProps = {
  variant: 'solid'
};
export default asSingleStyleConfig({
  baseStyle,
  variants,
  defaultProps
});